import React from 'react';
import useUserStore from '../stores/userStore';
import Usuario from '../model/Usuario/Usuario';
import { PermissaoWrapperHelper as Helper } from './PermissaoWrapperHelper';

interface PermissaoWrapperProps {
    children: React.ReactNode;
    permissoesRequiridas: string[];
    bancaIdFromComponent?: string | null;
    verificarQualquerPermissao?: boolean;
}

const PermissaoWrapper: React.FC<PermissaoWrapperProps> = ({
    children,
    permissoesRequiridas,
    bancaIdFromComponent = null,
    verificarQualquerPermissao = false,
}) => {
    const usuario = useUserStore((state) => state.usuario) as Usuario | null;

    // Se o usuário não estiver autenticado ou não tiver perfil, não renderiza nada
    if (!usuario || !usuario.perfil) {
        return <></>;
    }


    // Extrai as permissões do usuário
    const permissoesUsuario = usuario.perfil.permissoes.map((p) => p.nome);

    // Verifica se o usuário tem as permissões necessárias
    const hasRequiredPermissoes = Helper.verificarPermissoes({
        permissoesUsuario,
        permissoesRequiridas,
        bancaIdFromComponent,
        verificarQualquerPermissao,
    });

    // Renderiza os children apenas se o usuário tiver as permissões necessárias
    return hasRequiredPermissoes ? <>{children}</> : <></>;
};

export default PermissaoWrapper;